
import PropTypes from 'prop-types';
import PersonIcon from '@mui/icons-material/Person';
import SvgIcon from '@mui/material/SvgIcon';
import { Box, ButtonBase } from '@mui/material';
import Badge from '@mui/material/Badge';

export const SideNavAdminItem = (props) => {
  const { active = false, disabled, title, newData, requestsCounter } = props;

  return (
    <li>
      <ButtonBase
        sx={{
          alignItems: 'center',
          borderRadius: 1,
          display: 'flex',
          justifyContent: 'flex-start',
          pl: '16px',
          pr: '16px',
          py: '0px',
          textAlign: 'left',
          width: '100%',
          ...(active && {
            backgroundColor: 'rgba(255, 255, 255, 0.04)'
          }),
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.04)'
          }
        }}
      >
          <Box
            component="span"
            sx={{
              alignItems: 'center',
              color: 'neutral.400',
              display: 'inline-flex',
              justifyContent: 'center',
              mr: 2,
              ...(active && {
                color: 'primary.main'
              })
            }}
          >
          <SvgIcon fontSize="small">
            <PersonIcon />
          </SvgIcon>
          </Box>
        <Box
          component="span"
          sx={{
            color: 'neutral.400',
            flexGrow: 1,
            fontFamily: (theme) => theme.typography.fontFamily,
            fontSize: 14,
            fontWeight: 600,
            lineHeight: '20px',
            whiteSpace: 'nowrap',
            ...(active && {
              color: 'common.white'
            }),
            ...(disabled && {
              color: 'neutral.500'
            })
          }}
        >
          {title}
        </Box>
        <Badge
                badgeContent={newData}
                color="error"
                sx={{pl: 2}}
          >
          </Badge>
        <Badge
                badgeContent={requestsCounter}
                color="warning"
                sx={{pl: 3}}
          >
          </Badge> 
      </ButtonBase>
    </li>
  );
};

SideNavAdminItem.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  external: PropTypes.bool,
  icon: PropTypes.node,
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
};
